import { render, staticRenderFns } from "./FinalizarInclusao.vue?vue&type=template&id=70084e23&"
import script from "./FinalizarInclusao.vue?vue&type=script&lang=js&"
export * from "./FinalizarInclusao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports